import type CalendarEvent from 'owa-calendar-types/lib/types/CalendarEvent';
import type EmailAddressWrapper from 'owa-service/lib/contract/EmailAddressWrapper';
import { displayNewAppointmentFormApiHandler } from 'owa-calendar-addins-helpers';

export const displayNewAppointmentForm = (event: CalendarEvent) => (
    requiredAttendees?: EmailAddressWrapper[],
    optionalAttendees?: EmailAddressWrapper[],
    start?: number,
    end?: number,
    location?: string,
    resources?: string[],
    subject?: string,
    body?: string
) => {
    displayNewAppointmentFormApiHandler(
        'AddIns',
        event.ParentFolderId,
        requiredAttendees,
        optionalAttendees,
        start,
        end,
        location,
        resources,
        subject,
        body
    );
};
